<label
  *ngIf="label"
  for="{{ inputId }}"
  [ngClass]="{ 'dark-label': isDarkMode() }">
  <span class="asterik-color" *ngIf="required">*</span>{{ label }}
</label>
<input
  matInput
  type="date"
  [id]="inputId"
  class="form-control"
  [name]="inputName"
  [formControl]="controlname"
  (input)="onInput.emit($event)"
  [readonly]="readonly"
  autocomplete="off"
  [placeholder]="placeholder"
  [ngClass]="{
    invalid:
      formSubmitted && controlname?.invalid && !controlname?.hasError('pattern')
  }"
  [min]="minDate"
  [max]="maxDate"
/>

<div
  *ngIf="
    formSubmitted && controlname?.invalid && !controlname?.hasError('pattern')
  "
  class="error-message"
>
  <p class="ename">{{ errorMessage }}</p>
</div>
